import { donuts, drinks, icecream, sweetTreats, snacks, toys } from './items';
import HeadingGif from './gifs/heading.gif';
import BouncyCastlesVideo from './gifs/BouncyCastles.mp4';
import MascotsVideo from './gifs/Mascots.mp4';
import Logo from './Standard Logo - Horizontal.svg';
import QRCode from './AllergensLink.png';
import NCASS_LOGO from './NCASS-LOGO.jpg';
import FOOD_HYGINE_RATING from './FHR.svg';

const getAssetUrl = asset => (typeof asset === 'string' ? asset : asset.default);

const getProductImageUrls = productGroups => productGroups
  .flatMap(products => products.map(product => product.image))
  .filter(Boolean)
  .map(getAssetUrl);

const mediaAssetUrls = [
  HeadingGif,
  BouncyCastlesVideo,
  MascotsVideo,
  Logo,
  QRCode,
  NCASS_LOGO,
  FOOD_HYGINE_RATING,
  ...getProductImageUrls([donuts, drinks, icecream, sweetTreats, snacks, toys]),
];

let preloadPromise;
let loadedCount = 0;

const uniqueAssetUrls = [...new Set(mediaAssetUrls.map(getAssetUrl))];
const isVideoAsset = url => /\.(mp4|webm)(\?|#|$)/i.test(url);

const waitForVideoReady = url => new Promise(resolve => {
  const video = document.createElement('video');
  const timeout = window.setTimeout(resolve, 8000);
  const finish = () => {
    window.clearTimeout(timeout);
    video.removeAttribute('src');
    video.load();
    resolve();
  };

  video.preload = 'auto';
  video.muted = true;
  video.playsInline = true;
  video.oncanplaythrough = finish;
  video.onloadeddata = finish;
  video.onerror = finish;
  video.src = url;
  video.load();
});

const preloadAsset = async url => {
  try {
    const response = await fetch(url, { cache: 'force-cache' });
    await response.blob();
  } catch (error) {
    await new Promise(resolve => {
      const image = new Image();
      image.onload = resolve;
      image.onerror = resolve;
      image.src = url;
    });
  }

  if (isVideoAsset(url)) {
    await waitForVideoReady(url);
  }
};

export const preloadMediaAssets = ({ onProgress } = {}) => {
  if (!preloadPromise) {
    loadedCount = 0;
    preloadPromise = Promise.all(uniqueAssetUrls.map(async url => {
      await preloadAsset(url);
      loadedCount += 1;
      onProgress?.({
        loaded: loadedCount,
        total: uniqueAssetUrls.length,
        percent: Math.round((loadedCount / uniqueAssetUrls.length) * 100),
      });
    })).then(() => undefined);
  } else if (loadedCount === uniqueAssetUrls.length) {
    onProgress?.({
      loaded: loadedCount,
      total: uniqueAssetUrls.length,
      percent: 100,
    });
  }

  return preloadPromise;
};
